import { CommunityPostListQueryVariables } from 'generated/resources/graphql'

import { CommunitiesDropdown } from 'modules/dashboard/components/Groups/types'

export type CommunityPostListFilters = Pick<
  CommunityPostListQueryVariables,
  'types' | 'groups' | 'perPage'
> & { pinned?: boolean }

type BackendPostType =
  | 'Posts::V2::Announcement'
  | 'Posts::V2::Birthday'
  | 'Posts::V2::Event'
  | 'Posts::V2::FirstDay'
  | 'Posts::V2::Kudo'
  | 'Posts::V2::Workiversary'

const typesFromCommunitiesDropdown = (
  communitiesDropdown: CommunitiesDropdown
): BackendPostType[] => {
  const { strategy, value } = communitiesDropdown

  if (strategy === 'group') {
    return ['Posts::V2::Announcement', 'Posts::V2::Event', 'Posts::V2::Kudo']
  }

  if (strategy === 'type' && value && typeof value === 'string') {
    return [`Posts::V2::${value}`]
  }

  return ['Posts::V2::Announcement', 'Posts::V2::Event', 'Posts::V2::Kudo']
}

const groupsFromDropdown = (dropdown: CommunitiesDropdown): number[] | undefined => {
  if (dropdown.strategy === 'group') return [Number(dropdown.value)]
}

const POSTS_PER_PAGE = 10

type GetQueryFiltersOptions = {
  pinned?: boolean
}

export const getQueryFiltersFromDropdown = (
  dropdown: CommunitiesDropdown,
  options?: GetQueryFiltersOptions
): CommunityPostListFilters => {
  const types = typesFromCommunitiesDropdown(dropdown)
  const groups = groupsFromDropdown(dropdown)

  return {
    types,
    groups,
    perPage: POSTS_PER_PAGE,
    ...(options?.pinned === true && { pinned: true }),
  }
}
